export default (getConversations, $user) => {
    return [
        {
            event: "Conversations\\ConversationParticipantsAdded",
            callback: (event) => {
                console.log("ConversationParticipantsAdded", event);
                if (event.participants.includes($user.id)) {
                    getConversations();
                }
            },
        },
        {
            event: "Conversations\\ConversationParticipantRemoved",
            callback: (event) => {
                console.log("ConversationParticipantRemoved", event);
                getConversations();
            },
        },
    ];
};
